export enum NotificationType {
   Info = "info",
   Warning = "warning",
   Error = "error",
   Success = "success",
   Cancel = "cancel"
}

export interface OptionsType {
   notification_class: string
   icon_class: string
   text_class: string
   action_class: string
}

export interface ActionType {
   label: string
   callback: () => null
}
